import { Component, OnInit, Inject } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from "@angular/common/http";
import { environment } from "../../../../environments/environment";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastService } from "@app/components/toastr/toast.service";

@Component({
  selector: "app-stream-create",
  templateUrl: "./stream-create.component.html",
  styleUrls: ["./stream-create.component.scss"],
})
export class StreamCreateComponent implements OnInit {
  public Form: FormGroup;
  submitted = false;
  message = null;
  class = null;
  action = null;
  keywords = [];

  constructor(
    private ActivatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private http: HttpClient,
    private router: Router,
    @Inject("API_ENDPOINT") private api_endpoint: string,
    private toast: ToastService
  ) { }

  ngOnInit() {
    this.action = "Submit";

    // ✅ Always build form first
    this.Form = this.formBuilder.group({
      name: ["", Validators.required],
      description: ["", Validators.required],
      keywords: ["", Validators.required],
      status: ["", Validators.required],
      priority: ["", Validators.required],
      image: ["", Validators.required],
      _id: [""],
    });

    // ✅ Now check route params
    this.ActivatedRoute.params.subscribe((params) => {
      const id = params["id"];

      if (id) {   // 🔹 Only fetch if id exists
        this.http
          .get<any>(`${environment.apiUrl}/streams/${id}`, {
            headers: {
              Userinfo: JSON.stringify({
                _id: localStorage.getItem("adminSess"),
                role: localStorage.getItem("userRole"),
              }),
            },
          })
          .subscribe(
            (data) => {
              if (data && data._id) {
                this.action = "Update";
                this.Form.patchValue({
                  _id: data._id,
                  name: data.name,
                  description: data.description,
                  status: data.status,
                  priority: data.priority,
                  image: data.image,
                  keywords: data.keywords,
                });
              }
            },
            (err: HttpErrorResponse) => {
              console.error("Error loading stream:", err);
            }
          );
      }
    });

    // ✅ Always load keywords (runs once, not repeatedly)
    this.http
      .get<any>(`${environment.apiUrl}/keywords/`, {
        headers: {
          Userinfo: JSON.stringify({
            _id: localStorage.getItem("adminSess"),
            role: localStorage.getItem("userRole"),
          }),
        },
      })
      .subscribe(
        (data) => {
          this.keywords = data.results;
        },
        (err) => console.error("Error loading keywords:", err)
      );
  }


  get f() {
    return this.Form.controls;
  }

  onFormSubmit() {
    this.submitted = true;

    if (this.Form.invalid) {
      return;
    }

    if (this.action == "Submit") {
      let data = {
        name: this.Form.value.name,
        description: this.Form.value.description,
        status: this.Form.value.status,
        priority: this.Form.value.priority,
        image: this.Form.value.image,
        "keywords": this.Form.value.keywords,
      };
      this.http
        .post<any>(`${environment.apiUrl}/streams/`, data, {
          headers: {
            Userinfo: JSON.stringify({
              _id: localStorage.getItem("adminSess"),
              role: localStorage.getItem("userRole"),
            }),
          },
        })
        .subscribe(
          (res) => {
            res.message == "Logged Out!"
              ? this.router.navigateByUrl("/auth/login")
              : "";
            if (res.status == "500") {
              this.message = res.message;
              this.class = "btn-primary rounded px-1 py-1";
              window.scrollTo(document.documentElement.clientWidth, 0);
              return 0;
            } else {
              this.message = "Successfully Added";
              this.class = "btn-success rounded px-1 py-1";
              this.toast.show("Successfully Added", "success");
              this.router.navigateByUrl("/stream/list");
            }
          },
          (err: HttpErrorResponse) => {
            console.error("Error saving Stream:", err);
            this.toast.show("Failed to save Stream", "error");
          }
        );
    } else {
      let data = {
        name: this.Form.value.name,
        description: this.Form.value.description,
        status: this.Form.value.status,
        image: this.Form.value.image,
        priority: this.Form.value.priority,
        "keywords": this.Form.value.keywords,
      };
      console.log(data);
      let id = this.Form.value._id;


      this.http
        .patch<any>(`${environment.apiUrl}/streams/${id}`, data, {
          headers: {
            Userinfo: JSON.stringify({
              _id: localStorage.getItem("adminSess"),
              role: localStorage.getItem("userRole"),
            }),
          },
        })
        .subscribe(
          (res) => {
            res.message == "Logged Out!"
              ? this.router.navigateByUrl("/auth/login")
              : "";
            if (res.status == "500") {
              this.message = res.message;
              this.class = "btn-primary rounded px-1 py-1";
              window.scrollTo(document.documentElement.clientWidth, 0);
              return 0;
            } else {
              this.message = "Successfully Updated";
              this.class = "btn-success rounded px-1 py-1";
              this.toast.show("Successfully Updated", "success");
              this.router.navigateByUrl("/stream/list");
            }
          },
          (err: HttpErrorResponse) => {
           console.error("Error saving Stream:", err);
            this.toast.show("Failed to save Stream", "error");
          }
        );
    }
  }
}
